
export const editorConfig = {
    plugins: [
    ],
    language: {
        ui: 'ar',
        content: 'ar'
    },
    toolbar: {
        items: [
        ]
    }
}
